export const msalConfig = {
    auth: {
        clientId: "af21725f-76b9-46ad-8e8c-73ee5c63d869",
        authority: "https://login.microsoftonline.com/57cf78e2-f6a3-4a93-b96d-7b5c95947b72",
        //  redirectUri: "http://localhost:3000",
        redirectUri: "https://assets.viscaria.com",
     //   redirectUri: "https://csassetinfoweb.azurewebsites.net",
    },
    cache: {
        cacheLocation: "sessionStorage", // This configures where your cache will be stored
        storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
    }
};

// Add scopes here for ID token to be used at Microsoft identity platform endpoints.
export const loginRequest = {
    scopes: ["api://assetregistry.copperstone.se/read"]
};

